import FormDataFormatter from "./FormDataFormatter";

export default class CatalogSerializer {

    static serialize(catalog) {
        return FormDataFormatter.getFormData({...catalog});
    }

    static unserialize(response) {
        const unserialized = {...response};
        unserialized.document = undefined;
        unserialized.files = [];
        unserialized.defaultFiles = response.document ? [response.document] : [];
        unserialized.defaultFileIds = response.document ? [response.document.id] : [];
        return unserialized;
    }

}


// WEBPACK FOOTER //
// ./web/src/services/CatalogSerializer.js